import React, {createContext, useState} from 'react';
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from 'swr';

const MyRequirementsContext = createContext();

const MyRequirementsProvider = ({ children }) => {
    const [error, setError] = useState({"error": false, "message": ""});
    const [requirement, setRequirement] = useState({"requirementTitle": "", "requirementDescription": ""});
    const [requirements, setRequirements] = useState([]);
    const [procedureId, setProcedureId] = useState("null");
    const [loading, setLoading] = useState(false);

    const fetcher = () => axios.get(`${API}/requirements/getrequirements/${procedureId}`).then(res => {
        return res.data.response
    });

    function useRequirements () {
        const {data, error} = useSWR(`${API}/requirements/getrequirements/${procedureId}`, fetcher);
        return {
            requirements: data,
            isLoading: !error && !data,
            isError: error
        }
    }

    const getRequirementsAdmin = async (nProcedureId) => {
        setError({"error": false, "message": ""});
        setLoading(true);
        await axios.get(`${API}/requirements/getrequirements/${nProcedureId}`, config).then(res => {
            if(res.data.error){
                if(res.data.status == "400-1"){
                    closeSession();
                }
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({"error": true, "message": res.data.response});
                return;
            }
            setRequirements(res.data.response);
        }).catch(err => {
            setError(defaultError);
        });
        setLoading(false);
    }

    const addRequirement = async (data, nProcedureId) => {
        setLoading(true);
        var formData = new FormData();
        formData.append("requirementTitle", data.requirementTitle);
        formData.append("requirementDescription", data.requirementDescription);
        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.post(`${API}/requirements/addrequirement/${nProcedureId}`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRequirementsAdmin(nProcedureId);
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const updateRequirement = async (data, idToUpdate)=>{
        const requirementId = idToUpdate.split(";")[0];
        const nProcedureId = idToUpdate.split(";")[1];
        setLoading(true);
        var formData = new FormData();
        formData.append("requirementTitle", data.requirementTitle);
        formData.append("requirementDescription", data.requirementDescription);

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.put(`${API}/requirements/updaterequirement/${requirementId}`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRequirementsAdmin(nProcedureId);
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const deleteRequirement = async(idToDelete) => {
        const requirementId = idToDelete.split(";")[0];
        const nProcedureId = idToDelete.split(";")[1];
        setLoading(true);
        try{
            const res = await axios.delete(`${API}/requirements/deleterequirement/${requirementId}`, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                await getRequirementsAdmin(nProcedureId);
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }
    return (
        <MyRequirementsContext.Provider value={{
            error,
            requirement,
            setRequirement,
            procedureId,
            setProcedureId,
            useRequirements,
            getRequirementsAdmin,
            requirements,
            loading,
            addRequirement,
            setError,
            deleteRequirement,
            updateRequirement
        }}>
            {children}
        </MyRequirementsContext.Provider>
    );
}

export { MyRequirementsProvider };
export default MyRequirementsContext;